<meta name="keywords" content="Shell Puntos" />
<div class="main-container">
  <div class="banner-container">
    <img
      class="banner-image"
      [src]="isMobile ? bannerMobile : bannerDesktop"
      alt="banner section program"
    />
    <div class="description-container">
      <div class="description">
        <div class="video-container">
          <video
            #videoPlayer1
            class="custom-video"
            (play)="isPlayingFirst = true"
            (pause)="isPlayingFirst = false"
          >
            <source src="../../../assets/video/section-program-video.mp4" type="video/mp4" />
            Tu navegador no soporta el tag de video.
          </video>
          <button class="play-btn" (click)="toggleVideo(videoPlayer1, 1)">
            <ng-container *ngIf="!isPlayingFirst">
              <img
                src="../../../assets/images/playVideo.svg"
                alt="Reproducir video"
              />
            </ng-container>
            <ng-container *ngIf="isPlayingFirst">
              <img
                src="../../../assets/images/pauseVideo.svg"
                alt="Pausar video"
              />
            </ng-container>
          </button>
        </div>
        <div class="shellbox-description">
          <h3>¿En qué consiste Shell Box?</h3>
          <h4>
            Shell Box es el programa de beneficios de Shell que te permite:
          </h4>
          <div class="benefits-points" *ngFor="let benefit of (isMobile && !showAll ? benefits.slice(0, 3) : benefits); let last = last">
            <span>.</span>
            <p>
              {{ benefit.descripcion }}
              <span class="see-more-text" *ngIf="isMobile && !showAll && last" (click)="toggleBenefits()">
                Leer más
              </span>
            </p>
          </div>
          <span class="see-more-text" *ngIf="isMobile && showAll" (click)="toggleBenefits()">
            Leer menos
          </span>
          <button (click)="downloadApp()">Descargar la App</button>
        </div>               
      </div>
    </div>
    <div class="description-container">
      <div class="description">
        <div class="shellbox-description">
          <h3>¿Cómo sumás puntos Shell Box?</h3>
          <p>
            Pagando desde la app de Shell Box o presentando tu DNI en nuestras
            estaciones de servicio
          </p>
        </div>
        <div class="options-shell">
          <div class="tabs-container">
            <div
              *ngFor="let tab of tabs"
              class="tab"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              <img
                [src]="selectedTab === tab.id ? tab.activeImage : tab.image"
                [alt]="tab.title"
                class="tab-image"
              />
              <span *ngIf="!isMobile || selectedTab === tab.id" [class.active]="selectedTab === tab.id">
                {{ tab.title }}
              </span>
            </div>
          </div>
        
          <div class="content-container">
            <div class="box-wrapper" *ngIf="selectedTab !== 'thirdTab'">
              <div *ngFor="let item of getBoxContent()">
                <div class="box-container">
                  <h3>{{ item.name }}</h3>
                  <div>
                    <span *ngFor="let detail of item.details">{{ detail }}</span>
                  </div>
                </div>
                <p class="minimum" *ngIf="item.minimum">{{ item.minimum }}</p>
              </div>
            </div>
          
            <div class="box-wrapper" *ngIf="selectedTab === 'thirdTab'">
              <ng-container *ngFor="let item of getBoxContent()">
                <div *ngIf="item.brand" class="box-container">
                  <div class="brand-container">
                    <div class="box-brand">
                      <div class="brand-first-type">
                        <p class="brand-name">{{ item.brand.name }}</p>
                        <div class="brand-type">
                          <p class="brand-model">{{ item.brand.type }}</p>
                          <p class="brand-variant">{{ item.brand.variants[0] }}</p>
                        </div>
                        <p class="variants">{{ item.brand.variants[1] }}</p>
                      </div>
                      <div class="brand-second-type">
                        <div class="type-name">
                          <p>{{ item.brand.secondType.type }}</p>
                          <p>{{ item.brand.secondType.variants[0] }}</p>   
                        </div>
                        <p>{{ item.brand.secondType.variants[1] }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
      </div>
    </div>
    <div class="points-container">
      <h2>¡Tus puntos valen!</h2>
      <div class="points-description">
        <p>Vas a poder canjear los puntos por descuentos en combustible V-Power, lubricantes y Tiendas Select.</p>
        <div *ngIf="pointsList.length > 0" class="points-list">
          <div class="points-text" *ngFor="let point of pointsList; let i = index">
            <img src="../../../assets/icon/icon-shell-program.svg" alt="icon shell">
            <div class="points-value">
              <span>{{ point.firstText }}</span>
              <span>{{ point.secondText }}</span>
            </div>          
          </div>
        </div>        
        <swiper *ngIf="isMobile" [config]="configPoints" class="swiper-mobile">
          <ng-container *ngFor="let point of pointsList">
            <ng-template swiperSlide>
              <div class="points-text">
                <img src="../../../assets/icon/icon-shell-program.svg" alt="icon shell">
                <div class="points-value">
                  <span>{{ point.firstText }}</span>
                  <span>{{ point.secondText }}</span>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </swiper>              
      </div>
    </div>
    <div class="add-points">
      <div class="add-container">
        <h3>Canjeá tus puntos</h3>
        <div class="types-bought">
          <p>En tus compras de</p>
          <div class="type-exchanges-container">
            <div class="type-exchanges" *ngFor="let exchange of typeExchangesList">
              <img [src]="exchange.icon" alt="icon">
              <span>{{ exchange.label }}</span>
            </div>
          </div>          
        </div>
        <div class="types-seller" *ngFor="let type of typesSellerList; let i = index" [ngClass]="{ 'second-item': i === 1 }">
          <p>{{ type.title }}</p>
          <div class="different-types">
            <img [src]="type.icon" alt="icon">
            <div class="see-more">
              <a [href]="type.linkUrl">{{ type.linkText }}</a>
              <img src="../../../assets/icon/icon-know-more.svg" alt="Conocé más" class="banner">
            </div>
          </div>
        </div>  
      </div>
      <img class="banner-image" [src]="isMobile ? mobileImage : desktopImage" alt="Suma puntos">
    </div>
    <div class="image-container">
      <div *ngFor="let image of (isMobile ? imagesListMobile : imagesList)">
        <img [src]="image.src" alt="image">
      </div>
    </div>     
    <div class="register-container">
      <div class="register-steps">
        <h3>¿Cómo me registro?</h3>
        <div class="register-description">
          <div class="register-options">
            <div class="from-web">
              <span>Desde la Web</span>
              <div class="register-now">
                <a href="/register">Registráte ahora</a>
                <img src="../../../assets/icon/icon-know-more.svg" alt="Conocé más">
              </div>
            </div>
            <div class="from-app">
              <span>Desde la App</span>
              <div class="stores-option">
                <a
                  href="https://apps.apple.com/ar/app/shell-box-pague-e-ganhe/id1037433060"
                  target="_blank"
                >
                  <img src="../../../assets/icon/icon-google-store-black.svg" alt="Google Play">
                </a>
                <a
                href="https://play.google.com/store/apps/details?id=com.raizen.acelera&pli=1"
                target="_blank"
                >
                <img src="../../../assets/icon/icon-app-store-black.svg" alt="App Store">
                </a>
              </div>
            </div>
          </div>
          <span>Además:</span>
          <p>Formá parte del programa de beneficios de Shell Box completando tus datos personales y validando tu cuenta.</p>
          <div class="add-shell">
            <a href="/ingresar">Empezar ahora</a>
            <img src="../../../assets/icon/icon-know-more.svg" alt="Conocé más">
          </div>
        </div>
      </div>
      <img class="banner" [src]="isMobile ? mobileImageRegister : desktopImageRegister" alt="Suma puntos">
    </div>  
  </div>
</div>
